import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatErr } from "../lib/api";
import { ScareLogo } from "../components/Brand";
import { postLoginPath } from "../components/AuthBits";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmailPage() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); setErr("Missing verification token."); return; }
    (async () => {
      try {
        const u = await verifyEmail(token);
        setState("ok");
        setTimeout(() => nav(postLoginPath(u), { replace: true }), 1200);
      } catch (e) { setState("error"); setErr(formatErr(e.response?.data?.detail) || e.message); }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md st-card p-10 st-fade-up text-center" data-testid="verify-email-page">
        <div className="flex justify-center mb-6"><ScareLogo size={36} /></div>
        {state === "verifying" && <p className="text-[#8a8a8a]" data-testid="verify-loading">Verifying your email…</p>}
        {state === "ok" && (
          <div data-testid="verify-success">
            <CheckCircle2 size={40} className="mx-auto text-[#22c55e]" />
            <h1 className="text-2xl font-bold mt-4">Email verified!</h1>
            <p className="text-[#bbb] mt-2">Taking you to set up your attraction…</p>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <XCircle size={40} className="mx-auto text-[#dc2626]" />
            <h1 className="text-2xl font-bold mt-4">Verification failed</h1>
            <p className="text-[#bbb] mt-2">{err}</p>
            <Link to="/login" className="st-btn st-btn-ghost mt-6 inline-flex">Back to sign in</Link>
          </div>
        )}
      </div>
    </div>
  );
}
